import { Route, Routes } from "react-router-dom";
import SettingsChecklistsCreate from "../views/settings/SettingsChecklistsCreate";
import SettingsChecklistsEdit from "../views/settings/SettingsChecklistsEdit";
import { SettingsChecklistsView } from "../views/settings/SettingsChecklistsView";

const SettingChecklistRoutes = (props: any) => {
  return (
    <Routes>
      <Route path='create' element={<SettingsChecklistsCreate isUpdateMode={false} {...props} />} />
      <Route
        path=':checklistId'
        element={<SettingsChecklistsEdit isUpdateMode={true} {...props} />}
      />
      <Route index element={<SettingsChecklistsView {...props} />} />
    </Routes>
  );
};

export default SettingChecklistRoutes;
